import { render } from "./CIS-Footer.vue?vue&type=template&id=5689c325&scoped=true"
import script from "./CIS-Footer.vue?vue&type=script&lang=js"
export * from "./CIS-Footer.vue?vue&type=script&lang=js"

import "./CIS-Footer.vue?vue&type=style&index=0&id=5689c325&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5689c325"]])

export default __exports__